module.exports = __webpack_public_path__ + "static/electronic-70d7f4437781c5c8b07ee680caef331b.m4a";